import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { getReport } from '@utils/stores/progress-report/getters/report'

const getTutor = (state: ProgressReportStore): ProgressReport['tutor'] | null => getReport(state)?.tutor || null

export const tutor = {
  getTutor: (state: ProgressReportStore): ProgressReport['tutor'] | null => getTutor(state),
  isTutor: (state: ProgressReportStore): boolean => !!getTutor(state),
}
